import script from "./SimulationResultsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SimulationResultsPage.vue?vue&type=script&setup=true&lang=js"

import "./SimulationResultsPage.vue?vue&type=style&index=0&id=d3151984&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3151984"]])

export default __exports__